"use client";

import { motion } from "framer-motion";
import { CalendarCheck, Sparkles } from "lucide-react";
import { Card } from "@heroui/card";

export function OtcPointsBanner() {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
      className="w-full"
    >
      <Card className="bg-yiedl-gray-900 border border-yiedl-primary/20 rounded-xl p-4 sm:p-6 shadow-lg">
        <div className="flex flex-col items-center gap-4 sm:gap-6">
          {/* Glassmorphic icon container with calendar icon */}
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.3, ease: "easeOut", delay: 0.1 }}
            className="relative"
          >
            <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-yiedl-primary/30 to-yiedl-primary/20 backdrop-blur-sm rounded-2xl flex items-center justify-center shadow-lg border border-yiedl-primary/30">
              <CalendarCheck className="w-8 h-8 sm:w-10 sm:h-10 text-yiedl-primary" />
            </div>
            {/* Decorative glow */}
            <div className="absolute inset-0 bg-yiedl-primary/20 rounded-2xl blur-xl -z-10" />
          </motion.div>

          {/* Text content */}
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, ease: "easeOut", delay: 0.2 }}
            className="text-center space-y-2 sm:space-y-3 max-w-md"
          >
            <h3 className="text-lg sm:text-xl font-semibold text-white flex items-center justify-center gap-2">
              <Sparkles className="w-5 h-5 text-yiedl-primary" />
              Weekly Points Distribution
            </h3>
            <p className="text-sm sm:text-base text-gray-400">
              You will{" "}
              <span className="font-semibold text-yiedl-primary">
                automatically receive weekly points
              </span>{" "}
              based on your performance. No action required!
            </p>
            <p className="text-sm sm:text-base text-gray-400">
              Points are calculated and distributed every week based on your
              activity and achievements.
            </p>
          </motion.div>
        </div>
      </Card>
    </motion.div>
  );
}
